export default {
  slices: [
    {
      field: 'ad_type',
      display: 'Ad Type',
      map: {
        'social_video': {
          display: 'Video',
          sortOrder: 1
        }
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/configuration/Max/config/metadata.js